import type { AbilityKey, Access } from "@crux/contracts";

/**
 * What an access allows, asked the way the server asks it
 * (`server/crates/api/src/auth/access.rs`), so a button is offered exactly
 * when its request would be let through.
 */

/** A switch, or one of the two rules built on top of them. */
export type Action = AbilityKey | "deleteFromLibrary" | "managePeople";

const holdsEverything = (access: Access): boolean => access.role !== "member";

export function can(access: Access, action: Action): boolean {
  if (holdsEverything(access)) return true;
  if (action === "managePeople") return false;
  // One question can feed other brands, so deleting it needs every brand.
  if (action === "deleteFromLibrary") {
    return access.brands.kind === "all" && access.abilities.questions;
  }
  return access.abilities[action];
}
